export default {
    "language": "Sprache",
    "title": "",
}
